const DAT_EQUIPMENT_SEARCH_HOSTNAMES = ['one.dat.com', 'one.staging.dat.com'];
const DAT_EQUIPMENT_SEARCH_PATH = '/search-equipment';

export function matchDATEquipmentSearch(url: string): boolean {
  let parsed: URL;
  try {
    parsed = new URL(url);
  } catch {
    return false;
  }
  return (
    parsed.protocol === 'https:' &&
    DAT_EQUIPMENT_SEARCH_HOSTNAMES.includes(parsed.hostname) &&
    (parsed.pathname === DAT_EQUIPMENT_SEARCH_PATH ||
      parsed.pathname.startsWith(`${DAT_EQUIPMENT_SEARCH_PATH}/`))
  );
}
